import {
  ExternalLink,
  Page,
  ProductSpecificationGroup,
  ProductSpecificationItemMultiple,
  ProductSpecificationItemReference,
  ProductSpecificationItemText,
  ProductSpecificationItemUnit,
  ProductSpecificationItemWithMultiple,
  Reference,
} from '@Generated/graphql'

export const isProductSpecificationGroupItemMultiple = (item: ProductSpecificationItemWithMultiple | null):
  item is ProductSpecificationItemMultiple => item?.__typename === 'ProductSpecificationItemMultiple'
export const isProductSpecificationGroupItemUnit = (item: ProductSpecificationItemWithMultiple | null):
  item is ProductSpecificationItemUnit => item?.__typename === 'ProductSpecificationItemUnit'
export const isProductSpecificationGroupItemReference = (item: ProductSpecificationItemWithMultiple | null):
  item is ProductSpecificationItemReference => item?.__typename === 'ProductSpecificationItemReference'
export const isProductSpecificationGroupItemText = (item: ProductSpecificationItemWithMultiple | null):
  item is ProductSpecificationItemText => item?.__typename === 'ProductSpecificationItemText'
export const isProductSpecificationReferencePage = (reference?: Reference | null):
  reference is Page => reference?.__typename === 'Page'
export const isProductSpecificationReferenceExternalLink = (reference?: Reference | null):
  reference is ExternalLink => reference?.__typename === 'ExternalLink'

export type SpecificationsForProduct = {
  groups: ProductSpecificationGroup[]
  id: string
  name: string
}
